import assetTypeService from "../../../../services/assetService/assetTypeService";
import { CACHE_KEY_ASSETTYPES } from "../../../../utils/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AssetTypeInterface } from "../../../../models/AssetModel/AssetType";

interface AddAssetTypesContext {
  previousAssetTypes: AssetTypeInterface[];
}

const useAddAssetTypes = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    AssetTypeInterface,
    Error,
    AssetTypeInterface,
    AddAssetTypesContext
  >({
    mutationFn: assetTypeService.Save,

    onMutate: () => {
      const previousAssetTypes =
        queryClient.getQueryData<AssetTypeInterface[]>([
          CACHE_KEY_ASSETTYPES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      return { previousAssetTypes };
    },

    onSuccess: (savedAssetType) => {
      queryClient.setQueryData<AssetTypeInterface[]>(
        [
          CACHE_KEY_ASSETTYPES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        (assetTypes) =>
          assetTypes ? [savedAssetType, ...assetTypes] : [savedAssetType]
      );
    },

    onError: (error, newAssetType, context) => {
      if (!context) return;

      queryClient.setQueryData<AssetTypeInterface[]>(
        [
          CACHE_KEY_ASSETTYPES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousAssetTypes
      );
    },
  });
};

export default useAddAssetTypes;
